import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
export const BarWithTitle = (props) => {
    const { children } = props;
    return (React.createElement(AppBar, { position: "absolute", style: { position: 'relative', backgroundColor: '#000' } },
        React.createElement(Toolbar, null,
            React.createElement(Typography, { variant: "h6", color: "inherit", noWrap: true }, children))));
};
